<template>
  <v-container id="reference-term-list">
    <app-city-header :payload="payload" v-if="isAuthenticated">
    </app-city-header>

    <v-row>
      <v-col>
        <app-group-solution-by-city-combobox
          :filter="filter"
          @changeGroupSolution="changedGroup()"
          :onlyEnableGroupSolutionList="true"
        ></app-group-solution-by-city-combobox>
      </v-col>
      <v-col>
        <app-city-solution-combobox
          :filter="filter"
          :allSolutions="
            filter.municipioGrupoSolucao.municipioGrupoSolucaoId
              ? filteredAllSolutions
              : allTrueSolutions
          "
          :municipioSolucao="municipioSolucao"
          @changeSolution="changedSolutions()"
        ></app-city-solution-combobox>
      </v-col>
      <v-col>
        <app-city-task-combobox
          :filter="municipioTarefa"
          :itens="
            municipioSolucao.municipioSolucao.municipioSolucaoId ||
            filter.municipioGrupoSolucao.municipioGrupoSolucaoId
              ? filteredAllTasks
              : allTrueTasks
          "
          @changeTask="reloadValues()"
        ></app-city-task-combobox>
      </v-col>
    </v-row>

    <v-row>
      <v-tabs vertical>
        <v-tab>
          <v-icon left>mdi-axis-arrow</v-icon>
          Grupos de soluções
        </v-tab>
        <v-tab>
          <v-icon left>mdi-beaker-outline</v-icon>
          Soluções
        </v-tab>
        <v-tab>
          <v-icon left>mdi-calendar-check-outline</v-icon>
          Tarefas
        </v-tab>
        <v-tab>
          <v-icon left>mdi-book-search-outline</v-icon>
          Evidências
        </v-tab>

        <v-tab-item>
          <v-col>
            <app-axis-list
              :filter="filter"
              @reloadGroup="loadSolutions()"
            ></app-axis-list>
          </v-col>
        </v-tab-item>

        <v-tab-item>
          <app-solution-list
            ref="solutionList"
            :filter="filter"
            :municipioSolucao="municipioSolucao"
            :solutions="filter.solutions"
            :disabledSolutions="filter.disabledSolutions"
            @reloadSolutions="loadSolutions()"
          ></app-solution-list>
        </v-tab-item>

        <v-tab-item>
          <app-task-list
            :filter="filter"
            :municipioSolucaoP="municipioSolucao"
            :tasks="filter.tasks"
            :disabledTasks="filter.disabledTasks"
            @onSaveTask="reloadValues"
            @reloadTasks="loadTasks()"
          ></app-task-list>
        </v-tab-item>

        <v-tab-item>
          <app-evidence-list
            :filter="filter"
            :municipioTarefaP="municipioTarefa"
            :evidences="filter.evidences"
            @onDeleteEvidence="reloadValues"
            @reloadEvidences="loadEvidences()"
          ></app-evidence-list>
        </v-tab-item>
      </v-tabs>
    </v-row>
  </v-container>
</template>

<script>
import AppAxisList from "@/modules/axis/components/city/List";
import AppSolutionList from "@/modules/solution/components/city/List";
import AppTaskList from "@/modules/task/components/city/List";
import AppEvidenceList from "@/modules/evidence/components/city/List";
import {
  AppCityHeader,
  cityAPI,
  citySolutionAPI,
  cityTaskAPI,
  cityEvidenceAPI,
} from "@/modules/city";
import { mapActions, mapGetters } from "vuex";
import { AppGroupSolutionByCityCombobox } from "@/modules/axis";
import { AppCitySolutionCombobox } from "@/modules/solution";
import { AppCityTaskCombobox } from "@/modules/task";

export default {
  components: {
    AppAxisList,
    AppSolutionList,
    AppTaskList,
    AppEvidenceList,
    AppCityHeader,
    AppGroupSolutionByCityCombobox,
    AppCitySolutionCombobox,
    AppCityTaskCombobox,
  },

  data() {
    return {
      reload: {
        groups: false,
      },
      lastValue: {
        group: null,
      },
      headers: [
        {
          text: "#",
          sortable: false,
        },
        {
          text: "Nome",
          align: "left",
          sortable: false,
          value: "name",
        },
        { text: "Plano", value: "calories" },
        { text: "Carga Horária", value: "fat" },
      ],
      payload: {},
      breadcrumbs: [
        {
          text: "Grupos de Soluções",
          disabled: true,
          href: "termo-referencia",
        },
      ],
      municipioTarefa: {
        municipioTarefa: {},
      },
      municipioSolucao: {
        municipioSolucao: {},
      },
      filter: {
        municipioGrupoSolucao: {},
        municipioSolucao: {},
        municipioTarefa: {},
        solutions: [],
        disabledSolutions: [],
        tasks: [],
        evidences: [],
        disabledTasks: [],
      },
      solutions: [],
      tasks: [],
      allTrueTasks: [],
      allTrueSolutions: [],
      allTasks: [],
      filteredAllSolutions: [],
      filteredAllTasks: [],
      evidences: [],
    };
  },
  methods: {
    ...mapActions([
      "setLoading",
      "setConsultorCondutorMunicipio",
      "setConsultorEspecialistaMunicipio",
      "setAnalistaMunicipio",
      "setADMunicipio",
      "reloadAllValues",
    ]),
    reloadFilterGroup() {
      this.reloadAllValues();
    },
    loadCity() {
      this.setLoading(true);
      cityAPI
        .get(this.$route.params.id)
        .then((resp) => {
          this.payload = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter município");
        });
    },
    changedGroup() {
      this.municipioSolucao.municipioSolucao = {};
      this.municipioTarefa.municipioTarefa = {};
      this.reloadValues();
    },
    changedSolutions() {
      this.municipioTarefa.municipioTarefa = {};
      this.reloadValues();
    },
    reloadValues() {
      const { municipioGrupoSolucaoId } = this.filter.municipioGrupoSolucao;
      const { municipioSolucaoId } = this.municipioSolucao.municipioSolucao;
      const { municipioTarefaId } = this.municipioTarefa.municipioTarefa;

      if (municipioGrupoSolucaoId && municipioSolucaoId && municipioTarefaId) {
        this.filter.solutions = this.solutions.filter((i) => {
          return (
            i.municipioGrupoSolucaoId === municipioGrupoSolucaoId &&
            i.desabilitado === false &&
            i.municipioSolucaoId === municipioSolucaoId
          );
        });
        this.filter.disabledSolutions = this.solutions.filter((i) => {
          return (
            i.municipioGrupoSolucaoId === municipioGrupoSolucaoId &&
            i.desabilitado === true &&
            i.municipioSolucaoId === municipioSolucaoId
          );
        });
        this.filter.tasks = this.tasks.filter((i) => {
          return (
            i.desabilitado === false &&
            i.municipioSolucao.municipioGrupoSolucaoId ===
              municipioGrupoSolucaoId &&
            i.municipioSolucao.municipioSolucaoId === municipioSolucaoId &&
            i.municipioTarefaId === municipioTarefaId
          );
        });
        this.filter.disabledTasks = this.tasks.filter((i) => {
          return (
            i.desabilitado === true &&
            i.municipioSolucao.municipioGrupoSolucaoId ===
              municipioGrupoSolucaoId &&
            i.municipioSolucao.municipioSolucaoId === municipioSolucaoId &&
            i.municipioTarefaId === municipioTarefaId
          );
        });

        this.filter.evidences = this.evidences.filter(
          (ev) =>
            this.filter.solutions.some(
              (s) =>
                s.municipioSolucaoId === ev.municipioTarefa.municipioSolucaoId
            ) && ev.municipioTarefaId === municipioTarefaId
        );
      } else if (municipioGrupoSolucaoId && municipioSolucaoId) {
        this.filter.solutions = this.solutions.filter((i) => {
          return (
            i.municipioGrupoSolucaoId === municipioGrupoSolucaoId &&
            i.desabilitado === false &&
            i.municipioSolucaoId === municipioSolucaoId
          );
        });

        this.filter.disabledSolutions = this.solutions.filter((i) => {
          return (
            i.municipioGrupoSolucaoId === municipioGrupoSolucaoId &&
            i.desabilitado === true &&
            i.municipioSolucaoId === municipioSolucaoId
          );
        });

        this.filter.tasks = this.tasks.filter((i) => {
          return (
            i.municipioSolucao.municipioGrupoSolucaoId ===
              municipioGrupoSolucaoId &&
            i.desabilitado === false &&
            i.municipioSolucao.municipioSolucaoId === municipioSolucaoId
          );
        });

        this.filter.disabledTasks = this.tasks.filter((i) => {
          return (
            i.municipioSolucao.municipioGrupoSolucaoId ===
              municipioGrupoSolucaoId &&
            i.desabilitado === true &&
            i.municipioSolucao.municipioSolucaoId === municipioSolucaoId
          );
        });

        this.filteredAllTasks = this.tasks.filter((i) => {
          return (
            i.municipioSolucao.municipioGrupoSolucaoId ===
              municipioGrupoSolucaoId &&
            i.municipioSolucao.municipioSolucaoId === municipioSolucaoId
          );
        });

        this.filter.evidences = this.evidences.filter((ev) =>
          this.filter.solutions.some(
            (s) =>
              s.municipioSolucaoId === ev.municipioTarefa.municipioSolucaoId
          )
        );
      } else if (municipioSolucaoId && municipioTarefaId) {
        this.filter.solutions = this.solutions.filter((i) => {
          return (
            i.desabilitado === false &&
            i.municipioSolucaoId === municipioSolucaoId &&
            i.municipioTarefaId === municipioTarefaId
          );
        });

        this.filter.disabledSolutions = this.solutions.filter((i) => {
          return (
            i.desabilitado === true &&
            i.municipioSolucaoId === municipioSolucaoId &&
            i.municipioTarefaId === municipioTarefaId
          );
        });

        this.filter.tasks = this.tasks.filter((i) => {
          return (
            i.desabilitado === false &&
            i.municipioSolucao.municipioSolucaoId === municipioSolucaoId &&
            i.municipioTarefaId === municipioTarefaId
          );
        });

        this.filter.disabledTasks = this.tasks.filter((i) => {
          return (
            i.desabilitado === true &&
            i.municipioSolucao.municipioSolucaoId === municipioSolucaoId &&
            i.municipioTarefaId === municipioTarefaId
          );
        });

        this.filteredAllTasks = this.tasks.filter((i) => {
          return (
            i.municipioSolucao.municipioSolucaoId === municipioSolucaoId &&
            i.municipioTarefaId === municipioTarefaId
          );
        });

        this.filter.evidences = this.evidences.filter(
          (ev) =>
            this.solutions.some(
              (s) =>
                s.municipioSolucaoId === ev.municipioTarefa.municipioSolucaoId
            ) && ev.municipioTarefaId === municipioTarefaId
        );
      } else if (municipioGrupoSolucaoId) {
        this.filter.solutions = this.solutions.filter((i) => {
          return (
            i.municipioGrupoSolucaoId === municipioGrupoSolucaoId &&
            i.desabilitado === false
          );
        });

        this.filter.disabledSolutions = this.solutions.filter((i) => {
          return (
            i.municipioGrupoSolucaoId === municipioGrupoSolucaoId &&
            i.desabilitado === true
          );
        });

        this.filteredAllSolutions = this.solutions.filter((i) => {
          return i.municipioGrupoSolucaoId === municipioGrupoSolucaoId;
        });

        this.filter.tasks = this.tasks.filter(
          (i) =>
            i.municipioSolucao.municipioGrupoSolucaoId ===
              municipioGrupoSolucaoId && i.desabilitado === false
        );

        this.filter.disabledTasks = this.tasks.filter(
          (i) =>
            i.municipioSolucao.municipioGrupoSolucaoId ===
              municipioGrupoSolucaoId && i.desabilitado === true
        );

        this.filteredAllTasks = this.tasks.filter((i) => {
          return (
            i.municipioSolucao.municipioGrupoSolucaoId ===
            municipioGrupoSolucaoId
          );
        });

        this.filter.evidences = this.evidences.filter((ev) =>
          this.filter.solutions.some(
            (s) =>
              s.municipioSolucaoId === ev.municipioTarefa.municipioSolucaoId &&
              municipioGrupoSolucaoId === s.municipioGrupoSolucaoId
          )
        );
      } else if (municipioSolucaoId) {
        this.filter.solutions = this.solutions.filter((i) => {
          return (
            i.municipioSolucaoId === municipioSolucaoId &&
            i.desabilitado === false
          );
        });
        this.filter.disabledSolutions = this.solutions.filter((i) => {
          return (
            i.municipioSolucaoId === municipioSolucaoId &&
            i.desabilitado === true
          );
        });
        this.filter.tasks = this.tasks.filter((i) => {
          return (
            i.desabilitado === false &&
            i.municipioSolucao.municipioSolucaoId === municipioSolucaoId
          );
        });
        this.filter.disabledTasks = this.tasks.filter((i) => {
          return (
            i.desabilitado === true &&
            i.municipioSolucao.municipioSolucaoId === municipioSolucaoId
          );
        });

        this.filteredAllTasks = this.tasks.filter((i) => {
          return i.municipioSolucao.municipioSolucaoId === municipioSolucaoId;
        });

        this.filter.evidences = this.evidences.filter((ev) =>
          this.filter.solutions.some(
            (s) =>
              s.municipioSolucaoId === ev.municipioTarefa.municipioSolucaoId
          )
        );
      } else if (municipioTarefaId) {
        this.filter.tasks = this.tasks.filter((i) => {
          return (
            i.municipioTarefaId === municipioTarefaId &&
            i.desabilitado === false
          );
        });
        this.filter.disabledTasks = this.tasks.filter((i) => {
          return (
            i.municipioTarefaId === municipioTarefaId && i.desabilitado === true
          );
        });

        this.filter.evidences = this.evidences.filter(
          (ev) =>
            this.filter.solutions.some(
              (s) =>
                s.municipioSolucaoId === ev.municipioTarefa.municipioSolucaoId
            ) && ev.municipioTarefaId === municipioTarefaId
        );
      } else {
        this.filter.solutions = this.solutions.filter(
          (i) => i.desabilitado === false
        );
        this.filter.disabledSolutions = this.solutions.filter(
          (i) => i.desabilitado === true
        );
        this.filter.tasks = this.tasks.filter(
          (item) => item.desabilitado === false
        );
        this.filter.disabledTasks = this.tasks.filter(
          (item) => item.desabilitado === true
        );

        this.filteredAllTasks = this.tasks;

        this.filteredAllSolutions = this.solutions;

        this.filter.evidences = this.evidences;
      }
    },
    loadSolutions() {
      this.setLoading(true);
      citySolutionAPI
        .listByCity(this.$route.params.id)
        .then((resp) => {
          this.solutions = resp.data;
          this.allTrueSolutions = resp.data.filter(
            (item) => item.desabilitado === false
          );

          this.filter.solutions = resp.data.filter(
            (item) => item.desabilitado === false
          );
          this.filter.disabledSolutions = resp.data.filter(
            (item) => item.desabilitado === true
          );

          this.setLoading(false);

          this.reloadValues();
          this.loadTasks();
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao listar soluções");
        });
    },
    loadTasks() {
      this.setLoading(true);
      cityTaskAPI
        .listByCity(this.$route.params.id)
        .then((resp) => {
          this.tasks = resp.data;
          this.allTrueTasks = resp.data.filter(
            (item) => item.desabilitado === false
          );
          this.filter.tasks = resp.data.filter(
            (item) => item.desabilitado === false
          );

          this.filter.disabledTasks = resp.data.filter(
            (item) => item.desabilitado === true
          );

          this.reloadValues();
          this.loadEvidences();
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao listar tarefas");
        });
    },
    loadEvidences() {
      this.setLoading(true);
      cityEvidenceAPI
        .listByCity(this.$route.params.id)
        .then((resp) => {
          this.evidences = resp.data.filter(
            (item) => item.desabilitado === false
          );
          this.filter.evidences = resp.data;
          this.reloadValues();
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao listar evidências");
        });
    },
  },
  mounted() {
    this.loadCity();
    this.loadSolutions();
    //this.loadTasks();
    //this.loadEvidences();
  },
  computed: {
    ...mapGetters([
      "loading",
      "isAdmin",
      "isConsultorCondutorMunicipio",
      "isConsultorEspecialistaMunicipio",
      "isADMunicipio",
      "isAuthenticated",
      "reloadTRGroup",
    ]),
  },
  watch: {
    reloadTRGroup: {
      handler(val, oldVal) {
        this.reloadValues();
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
@import "../style.scss";
</style>
